import moment from "moment";

const useFeatureReleaseTracker = () => {
  const afterKitLaunchDate = moment().isAfter(moment(process.env.MIX_KIT_LAUNCH_DATE));

  return {
    afterKitLaunchDate,
  };
};

export default useFeatureReleaseTracker;
